import React, { useEffect, useState } from "react";
import { fetchCmsContent } from "../services/fetchCmsContent";
import { postMessage } from "../services/api";
import { validateMobile } from "../utils/chatUtils";
import { toast } from "react-toastify";

import ChatSidebar from "../components/CommonComponents/ChatSidebar";
import ChatHeader from "../components/CommonComponents/ChatHeader";
import Disclaimer from "../components/CommonComponents/Disclaimer";
import LoaderPage from "../components/CommonComponents/Loader/LoaderPage";

import "../images/css/contact.css";

interface FeedbackComplaintsItem {
  title: string;
  slug: string;
  content: string;
}

const Feedback: React.FC = () => {
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [mobile, setMobile] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [category, setCategory] = useState<string>("feedback");
  const [feedbackComplaints, setFeedbackComplaints] = useState<FeedbackComplaintsItem | null>(null);
  const [loader, setLoader] = useState(false);
  const req = `<span style="color: red">*</span>`

  useEffect(() => {
    fetchCmsContent("Feedback & Complaints", "/api/cms/feedback-complaints", setFeedbackComplaints, setLoader);
  }, []);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoader(true);

    if (!validateMobile(mobile)) {
      toast.error("Invalid mobile number!", { position: "top-right", autoClose: 3000 });
      setLoader(false);
      return;
    }

    if (!email.includes("@")) {
      toast.error("Invalid email format!", { position: "top-right", autoClose: 3000 });
      setLoader(false);
      return;
    }

    try {
      const response = await postMessage("/api/feedback", { name, email, mobile, message, category }, false);
      if (response.success) {
        toast.success(response.msg, { position: "top-right", autoClose: 1000 });
        setName("");
        setEmail("");
        setMessage("");
        setMobile("");
        setCategory("feedback")
      }
      else {
        toast.error(response.msg, { position: "top-right", autoClose: 3000 });
      }
    }
    catch (error) {
      toast.error("An error occurred while submitting feedback.", { position: "top-right", autoClose: 3000 });
    }
    finally {
      setLoader(false);
    }
  };

  return (
    <div>
      <ChatHeader />
      <div className="chat-row-container flex-columns columns-full">
        <ChatSidebar />
        <div className="chat-row-container flex-columns columns-full">
          <div className="max-w-4xl mx-auto p-6 right-content-wrapper h-100dvh">
            <div className="chat-title">
              <h1>Feedback & Complaints</h1>
            </div>
            <div className="cms-wrapper">
              <div className="cms-wrapper-inner h-cal">
                {loader ? (
                  <LoaderPage />
                ) : (
                  <>
                    <form onSubmit={handleSubmit} className="contact-form">

                      <div>
                        <label>Name<span dangerouslySetInnerHTML={{ __html: req }} /></label>
                        <input
                          type="text"
                          placeholder="Enter Your Name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required />
                      </div>

                      <div>
                        <label>Email<span dangerouslySetInnerHTML={{ __html: req }} /></label>
                        <input
                          type="email"
                          placeholder="Enter Your Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required />
                      </div>

                      <div className="mobile-wrap">
                        <label>Mobile<span dangerouslySetInnerHTML={{ __html: req }} /></label>
                        <input
                          type="text"
                          placeholder="Enter Your Mobile"
                          value={mobile}
                          onChange={(e) => setMobile(e.target.value)}
                          required />
                      </div>

                      <div className="feedback-wrap">
                        <label>Feedback Type<span dangerouslySetInnerHTML={{ __html: req }} /></label>
                        <select name="feedbackType" value={category} onChange={(e) => setCategory(e.target.value)} required>
                          <option value="feedback">Feedback</option>
                          <option value="complaint">Complaint</option>
                        </select>
                      </div>

                      <div className="textarea-wrap">
                        <label>Message<span dangerouslySetInnerHTML={{ __html: req }} /></label>
                        <textarea
                          placeholder="Enter Your Message"
                          value={message}
                          onChange={(e) => {
                            const inputValue = e.target.value;

                            if (inputValue.length > 255) {
                              toast.warning(`Message cannot exceed 255 characters!`);
                              return;
                            }
                            setMessage(inputValue);
                          }}
                          rows={6}
                          required />
                        <small>{message.length}/255</small>
                      </div>

                      <div className="form-submit">
                        <button type="submit" disabled={loader}>
                          {loader ? "Submitting..." : "Submit"}
                        </button>
                      </div>

                    </form>
                    <div className="complaint-notice">
                      <div dangerouslySetInnerHTML={{ __html: feedbackComplaints?.content || "" }}></div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Disclaimer />
    </div>
  );
};

export default Feedback